module.exports = __webpack_public_path__ + "img/20190418_154809_008.f24cb2e9.jpg";